const getDateSortTime = (dateStr) => {
  if (!dateStr) return null;
  const time = new Date(`${dateStr}T00:00:00`).getTime();
  return Number.isNaN(time) ? null : time;
};

const getCreatedAtSortTime = (session) => {
  if (session?.createdAt?.toDate) return session.createdAt.toDate().getTime();
  if (session?.createdAt) return new Date(session.createdAt).getTime();
  return 0;
};

export const getDealerSessionSortTime = (session) => {
  const fromOrderDate = getDateSortTime(session?.orderDate);
  if (fromOrderDate != null) return fromOrderDate;
  const fromSessionDate = getDateSortTime(session?.sessionDate);
  if (fromSessionDate != null) return fromSessionDate;
  return getCreatedAtSortTime(session);
};

/** Tedarikçi alım listesi: sessionDate → createdAt */
export const getSupplierSessionSortTime = (session) => {
  const fromSessionDate = getDateSortTime(session?.sessionDate);
  if (fromSessionDate != null) return fromSessionDate;
  return getCreatedAtSortTime(session);
};

/** Yeniden eskiye (en güncel sipariş tarihi üstte) */
export const sortDealerSessionsByDate = (sessions = []) =>
  [...sessions].sort((a, b) => getDealerSessionSortTime(b) - getDealerSessionSortTime(a));

export const sortSupplierSessionsByDate = (sessions = []) =>
  [...sessions].sort((a, b) => getSupplierSessionSortTime(b) - getSupplierSessionSortTime(a));
